<template>
<div style="margin-top:200px">

     <section v-if="isShow(1)" :style="'background:url(' + require('@/assets/bg-top-right.png') +') fixed '">

          <div v-if="getSecen > 800" class="text-center  mb-12">
               <v-row v-if="!isLoading">
                    <v-col class="py-0 px-0" cols="4"></v-col>
                    <v-col class="py-0 px-0" cols="4">
                         <span :style="'font-weight: bold;font-size:18px; color:'+(settings[0] ? settings[0].color : '#2F839D')">{{ getName('P1S1HeadTitle') }}</span>
                         <h1 class="textSizeT">{{ getName('P1S1Title') }}</h1>
                         <div class="h-decor" :style="'background:' + (settings[0] ? settings[0].color : '#2F839D') "></div>
                    </v-col>

                    <v-col cols="3"></v-col>
                    <v-col id=" hidden-sm-and-down" cols="1"> 
                              <v-row @click="resultRoute"  class=" hand goToResult">
                                   <v-col  class="py-0 " cols="12" lg="7" md="7">
                                        <div  style="background:#fff; border-radius:50%;padding:15px" class="shadow-drop-center" size="140" >
                                             <v-img   style=" border-radius:30%"  width="250"  :src="require('@/assets/signature.gif')"></v-img> 
                                        </div>
                                   </v-col>
                                   <!-- <v-col class="py-5 hidden-s8-and-down" cols="3" lg="4" md="4">
                                        <h1 style="color: #888">{{$t('result')}}</h1>
                                        <h3 style="color: #aaa">{{$t('clickHere')}}</h3>
                                   </v-col> -->
                              </v-row> 
                    </v-col>
               </v-row>
               <v-row v-else>
                    <v-col class="py-0 px-0" cols="4"></v-col>
                    <v-col cols="4">
                         <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                         <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                         <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                    </v-col>
                    <v-col class="py-0 px-0" cols="4"></v-col>
               </v-row>
          </div>
          <div v-else class="text-center  mb-12">
               <div v-if="!isLoading">
                    <span :style="'font-weight: bold;font-size:18px; color:'+(settings[0] ? settings[0].color : '#2F839D')">{{ getName('P1S1HeadTitle') }}</span>
                    <h1 class="textSizeT">{{ getName('P1S1Title') }}</h1>
                    <div class="h-decor" :style="'background:' + (settings[0] ? settings[0].color : '#2F839D') "></div>
               </div>
               <div v-else>
                    <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                    <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                    <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
               </div>
          </div>
          <div>
               <v-row>
                    <v-col cols="12" lg="5" md="5" sm="12">
                         <v-row>
                              <v-col cols="12">
                                   <v-hover v-if="!isLoading" v-slot:default="{ hover }">
                                        <v-card class="mx-auto" color="grey lighten-4" max-width="100%">
                                             <v-img :aspect-ratio="16/9" max-height="531" :src="'home/'+ (checkDefault('P1S1Img1') ? checkDefault('P1S1Img1').img : '') | URL">
                                                  <v-expand-transition>
                                                       <div v-if="hover" class="d-flex transition-fast-in-fast-out grey darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                                                       </div>
                                                  </v-expand-transition>
                                                  <template v-slot:placeholder>
                                                       <v-row class="fill-height ma-0" align="center" justify="center">
                                                            <v-progress-circular indeterminate color="grey lighten-5 "></v-progress-circular>
                                                       </v-row>
                                                  </template>
                                             </v-img>
                                        </v-card>
                                   </v-hover>
                                   <v-skeleton-loader v-else ref="skeleton" type="image"></v-skeleton-loader>
                              </v-col>
                              <v-col cols="6">
                                   <v-hover v-if="!isLoading" v-slot:default="{ hover }">
                                        <v-card class="mx-auto" color="grey lighten-4" max-width="100%">
                                             <v-img :aspect-ratio="16/9" :src="'home/'+ (checkDefault('P1S1Img2') ? checkDefault('P1S1Img2').img : '') | URL">
                                                  <v-expand-transition>
                                                       <div v-if="hover" class="d-flex transition-fast-in-fast-out grey darken-2 v-card--reveal display-3 white--text" style="height: 100%;">

                                                       </div>
                                                  </v-expand-transition>
                                             </v-img>
                                        </v-card>
                                   </v-hover>
                                   <v-skeleton-loader v-else ref="skeleton" type="image"></v-skeleton-loader>
                              </v-col>
                              <v-col cols="6">
                                   <v-hover v-if="!isLoading" v-slot:default="{ hover }">
                                        <v-card class="mx-auto" color="grey lighten-4" max-width="100%">
                                             <v-img :aspect-ratio="16/9" :src="'home/'+ (checkDefault('P1S1Img3') ? checkDefault('P1S1Img3').img : '') | URL">
                                                  <v-expand-transition>
                                                       <div v-if="hover" class="d-flex transition-fast-in-fast-out grey darken-2 v-card--reveal display-3 white--text" style="height: 100%;">

                                                       </div>
                                                  </v-expand-transition>
                                             </v-img>
                                        </v-card>
                                   </v-hover>
                                   <v-skeleton-loader v-else ref="skeleton" type="image"></v-skeleton-loader>
                              </v-col>
                         </v-row>
                    </v-col>
                    <v-col :style="'background:url(' + require('@/assets/bg-top-right.png') +') '" cols="12" lg="6" md="6" sm="12">
                         <p class="textSizeP mx-8">{{ getName('P1S1Prag1') }}</p>
                         <!-- <p class="textSizeP mx-8">Come and experience dentistry carried out a little differently in our Private Practice. A practice where you will:</p> -->
                         <ul v-if="!isLoading">
                              <li class="textSizeP mx-8" v-if="getName('P1S1Elem1') != ''">
                                   <v-icon class="mx-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-check</v-icon>{{ getName('P1S1Elem1') }}
                              </li>
                              <li class="textSizeP mx-8" v-if="getName('P1S1Elem2') != ''">
                                   <v-icon class="mx-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-check</v-icon>{{ getName('P1S1Elem2') }}
                              </li>
                              <li class="textSizeP mx-8" v-if="getName('P1S1Elem3') != ''">
                                   <v-icon class="mx-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-check</v-icon>{{ getName('P1S1Elem3') }}
                              </li>
                              <li class="textSizeP mx-8" v-if="getName('P1S1Elem4') != ''">
                                   <v-icon class="mx-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-check</v-icon>{{ getName('P1S1Elem4') }}
                              </li>
                              <li class="textSizeP mx-8" v-if="getName('P1S1Elem5') != ''">
                                   <v-icon class="mx-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-check</v-icon>{{ getName('P1S1Elem5') }}
                              </li>
                         </ul>
                         <ul v-else>
                              <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                              <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                              <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                              <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                              <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader><br><br>
                         </ul>
                         <p v-if="!isLoading" class="textSizeST  mt-12 mx-8">{{ getName('P1S1SouTitle1') }} </p>
                         <v-skeleton-loader v-else ref="skeleton" type="text"></v-skeleton-loader>
                         <p v-if="!isLoading" class="textSizeP mx-8">{{ getName('P1S1Prag2') }}</p>
                         <v-skeleton-loader v-else ref="skeleton" type="list-item-three-line"></v-skeleton-loader>
                         <!-- <p class="textSizeP mx-8">Our vision is to be one of the leading dental clinic in the area, expanding our services to reach additional community members. We work to be trusted by patients, a valued partner in the community.</p> -->
                    </v-col>
               </v-row>
          </div>

     </section>

     <section v-if="isShow(2)" :style="'background:url(' + require('@/assets/bg-department.png') +') fixed '" class="px-0 mx-12" style="  margin-top: 140px">
          <div v-if="!isLoading" class="text-center  mb-12">
               <span :style="'font-weight: bold;font-size:18px; color:'+(settings[0] ? settings[0].color : '#2F839D')">{{ getName('P1S2HeadTitle') }}</span>
               <h1 class="textSizeT">{{ getName('P1S2Title') }}</h1>
               <div class="h-decor" :style="'background:' + (settings[0] ? settings[0].color : '#2F839D') "></div>
          </div>
          <div v-else>
               <v-skeleton-loader ref="skeleton" type="list-item"></v-skeleton-loader>
               <v-skeleton-loader ref="skeleton" type="list-item"></v-skeleton-loader>
          </div>
          <div>
               <v-row v-if="!isLoading">
                    <v-col cols="12" lg="4" md="4" sm="4">
                         <v-card class="mx-auto2" max-width="400">
                              <div class="text-center">
                                   <v-icon size="80" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-hand-heart</v-icon>
                              </div>
                              <v-card-subtitle class="mb-3  mt-0 text-center"><span :style="'font-weight: bold;font-size:22px; color:'+(settings[0] ? settings[0].color : '#2F839D')">{{ getName('P1S2SouTitle1') }}</span></v-card-subtitle>

                              <v-card-text class="text--primary text-center">
                                   <div class="textSizeP2">{{ getName('P1S2Prag1') }}</div>
                              </v-card-text>

                         </v-card>
                    </v-col>
                    <v-col cols="12" lg="4" md="4" sm="4">
                         <v-card class="mx-auto2" max-width="400">
                              <div class="text-center">
                                   <v-icon size="80" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-flask-round-bottom-empty-outline</v-icon>
                              </div>
                              <v-card-subtitle class="mb-3  mt-0 text-center"><span :style="'font-weight: bold;font-size:22px; color:'+(settings[0] ? settings[0].color : '#2F839D')">{{ getName('P1S2SouTitle2') }}</span></v-card-subtitle>

                              <v-card-text class="text--primary text-center">
                                   <div class="textSizeP2">{{ getName('P1S2Prag2') }}</div>
                              </v-card-text>

                         </v-card>
                    </v-col>
                    <v-col cols="12" lg="4" md="4" sm="4">
                         <v-card class="mx-auto2" max-width="400">
                              <div class="text-center">
                                   <v-icon size="80" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-head-lightbulb-outline</v-icon>
                              </div>
                              <v-card-subtitle class="mb-3  mt-0 text-center"><span :style="'font-weight: bold;font-size:22px; color:'+(settings[0] ? settings[0].color : '#2F839D')">{{ getName('P1S2SouTitle3') }}</span></v-card-subtitle>

                              <v-card-text class="text--primary text-center">
                                   <div class="textSizeP2">{{ getName('P1S2Prag3') }}</div>
                              </v-card-text>

                         </v-card>
                    </v-col>
               </v-row>
               <v-row v-else>
                    <v-col cols="4">
                         <v-skeleton-loader ref="skeleton" type="card"></v-skeleton-loader>
                    </v-col>
                    <v-col cols="4">
                         <v-skeleton-loader ref="skeleton" type="card"></v-skeleton-loader>
                    </v-col>
                    <v-col cols="4">
                         <v-skeleton-loader ref="skeleton" type="card"></v-skeleton-loader>
                    </v-col>
               </v-row>

          </div>
     </section>

     <section v-if="isShow(3)" :style="'background:url(' + require('@/assets/bg-top-left.png') +') fixed'" class=" mx-12" style="  margin-top: 140px">
          <div>
               <v-row>
                    <v-col cols="12" lg="5" md="5" sm="12">
                         <div class="mb-4">
                              <h1>{{ getName('P1S3SouTitle1') }}</h1>
                         </div>

                         <ul v-if="!isLoading">
                              <li class="textSizeP " v-if="getName('P1S3Elem1') != ''">
                                   <v-icon class="ma-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-hand-okay</v-icon><span> {{ getName('P1S3Elem1')  }}</span>
                              </li>
                              <li class="textSizeP " v-if="getName('P1S3Elem2') != ''">
                                   <v-icon class="ma-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-hand-okay</v-icon><span> {{ getName('P1S3Elem2')  }}</span>
                              </li>
                              <li class="textSizeP " v-if="getName('P1S3Elem3') != ''">
                                   <v-icon class="ma-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-hand-okay</v-icon><span> {{ getName('P1S3Elem3')  }}</span>
                              </li>
                              <li class="textSizeP " v-if="getName('P1S3Elem4') != ''">
                                   <v-icon class="ma-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-hand-okay</v-icon><span> {{ getName('P1S3Elem4')  }}</span>
                              </li>
                              <li class="textSizeP " v-if="getName('P1S3Elem5') != ''">
                                   <v-icon class="ma-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-hand-okay</v-icon><span> {{ getName('P1S3Elem5')  }}</span>
                              </li>
                              <li class="textSizeP " v-if="getName('P1S3Elem6') != ''">
                                   <v-icon class="ma-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-hand-okay</v-icon><span> {{ getName('P1S3Elem6')  }}</span>
                              </li>
                              <li class="textSizeP " v-if="getName('P1S3Elem7') != ''">
                                   <v-icon class="ma-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-hand-okay</v-icon><span> {{ getName('P1S3Elem7')  }}</span>
                              </li>
                              <li class="textSizeP " v-if="getName('P1S3Elem8') != ''">
                                   <v-icon class="ma-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-hand-okay</v-icon><span> {{ getName('P1S3Elem8')  }}</span>
                              </li>
                              <li class="textSizeP" v-if="getName('P1S3Elem9') != ''">
                                   <v-icon class="ma-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-hand-okay</v-icon><span> {{ getName('P1S3Elem9')  }}</span>
                              </li>
                              <li class="textSizeP " v-if="getName('P1S3Elem10') != ''">
                                   <v-icon class="ma-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-hand-okay</v-icon><span> {{ getName('P1S3Elem10')  }}</span>
                              </li>
                         </ul>
                         <ul v-else>
                              <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                              <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                              <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                              <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                              <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader><br><br>
                         </ul>

                    </v-col>
                    <v-col cols="12" lg="6" md="6" sm="12">
                         <v-hover v-if="!isLoading" v-slot:default="{ hover }">
                              <v-card class="mx-auto" color="grey lighten-4" max-width="100%">
                                   <v-img :src="'home/'+ (checkDefault('P1S3Img1') ? checkDefault('P1S3Img1').img : '') | URL">
                                        <v-expand-transition>
                                             <div v-if="hover" class="d-flex transition-fast-in-fast-out grey darken-2 v-card--reveal display-3 white--text" style="height: 100%;">

                                             </div>
                                        </v-expand-transition>
                                   </v-img>
                              </v-card>
                         </v-hover>
                         <v-skeleton-loader v-else ref="skeleton" type="image"></v-skeleton-loader>
                    </v-col>
               </v-row>
          </div>
     </section>

</div>
</template>

<script>
export default {
     data: () => ({
          arr: []
     }),
     methods: {
          resultRoute() {
               this.$router.push('resultats')
          },
          checkDefault(item) {
               for (let i = 0; i < this.website.length; i++) {
                    if (this.website[i].elementName == item) {
                         return this.website[i]
                    }
               }
          },
          isShow(item) {
               let array = this.$store.state.status.filter(e => e.idPage == 1)
               if (array) {
                    for (let i = 0; i < array.length; i++) {
                         if (array[i].idSection == item) {
                              return false
                         } else {
                              return true
                         }
                    }
               }
               return true
          },
     },
     computed: {
          getSecen() {
               return screen.width
          },

     },
     created() {

     }
}
</script>

<style scoped>
.v-card--reveal {
     align-items: center;
     bottom: 0;
     justify-content: center;
     opacity: .5;
     position: absolute;
     width: 100%;
}

ul {
     list-style: none;
     padding: 0;
     margin: 0;
}

li::before {
     content: "  ";
     /* or whatever color you prefer */
}
</style><style>
.scale-down-center {
     -webkit-animation: scale-down-center 0.4s cubic-bezier(0.250, 0.460, 0.450, 0.940) infinite alternate both;
     animation: scale-down-center 0.4s cubic-bezier(0.250, 0.460, 0.450, 0.940) infinite alternate both;
}

/* ----------------------------------------------
 * Generated by Animista on 2020-7-19 17:52:39
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation scale-down-center
 * ----------------------------------------
 */
@-webkit-keyframes scale-down-center {
     0% {
          -webkit-transform: scale(1);
          transform: scale(1);
     }

     100% {
          -webkit-transform: scale(0.5);
          transform: scale(0.5);
     }
}

@keyframes scale-down-center {
     0% {
          -webkit-transform: scale(1);
          transform: scale(1);
     }

     100% {
          -webkit-transform: scale(0.5);
          transform: scale(0.5);
     }
}

.shadow-drop-center {
     border-radius: 0 0 0 0;
     -webkit-animation: shadow-drop-center 0.4s cubic-bezier(0.250, 0.460, 0.450, 0.940) infinite alternate both;
     animation: shadow-drop-center 0.4s cubic-bezier(0.250, 0.460, 0.450, 0.940) infinite alternate both;
}

/* ----------------------------------------------
 * Generated by Animista on 2020-7-19 17:53:45
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation shadow-drop-center
 * ----------------------------------------
 */
@-webkit-keyframes shadow-drop-center {
     0% {
          -webkit-box-shadow: 0 0 0 0  rgba(224, 220, 2, 0.55);
          box-shadow: 0 0 0 0  rgba(224, 220, 2, 0.55);
     }

     100% {
          -webkit-box-shadow: 0 0 20px 0px  rgba(224, 220, 2, 0.55);
          box-shadow: 0 0 30px 0px  rgba(224, 220, 2, 0.55);
     }
}

@keyframes shadow-drop-center {
     0% {
          -webkit-box-shadow: 0 0 0 0  rgba(224, 220, 2, 0.55);
          box-shadow: 0 0 0 0  rgba(224, 220, 2, 0.55);
     }

     100% {
          -webkit-box-shadow: 0 0 20px 0px  rgba(224, 220, 2, 0.55);
          box-shadow: 0 0 40px 0px rgba(153, 153, 134, 0.55);
     }
}
</style>
